import { render, staticRenderFns } from "./GestioneReparto.vue?vue&type=template&id=ec2e1960&scoped=true&"
import script from "./GestioneReparto.vue?vue&type=script&lang=js&"
export * from "./GestioneReparto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2e1960",
  null
  
)

export default component.exports